// Test IDs for leads (list + detail) — see ./index.js.

// Blacklisting a lead: the action, its dialog, the banner and the list badge.
export const LEAD_BLACKLIST = {
	openButton: 'lead-blacklist-open-button',
	reasonInput: 'lead-blacklist-reason-input',
	confirmButton: 'lead-blacklist-confirm-button',
	cancelButton: 'lead-blacklist-cancel-button',
	banner: 'lead-blacklist-banner',
	removeButton: 'lead-blacklist-remove-button',
	badge: 'lead-blacklist-badge',
	bulkButton: 'lead-blacklist-bulk-button',
	menuItem: 'action-blacklist',
	tab: 'lead-tab-blacklisted',
};
